// extracted by mini-css-extract-plugin
export default {"link":"Categories_link__hs4HL","active":"Categories_active__ntapp","bold":"Categories_bold__CgMCG"};